import { createContext, useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { HomeDelivery } from '../Actions/HomeDelivery';
import { localStation } from '../Actions/LocationStations';
import { PaymentMethod } from '../Actions/PaymentMethod';
import { checkValidation, patterns } from '../utils/Validations';


export const DisplayContext = createContext(null);

const DisplayContextProvider = ({children}) => {
     const dispatch = useDispatch()
     const [showDeliveryOption, setShowDeliveryOption] = useState(0)
     const [showMobileDeliveryOption, setShowMobileDeliveryOption] = useState(0);
     const [showDeliveryCheckoutOption, setShowDeliveryCheckoutOption] = useState(0);
     const [cashOnDeliveryModal, setCashOnDeliveryModal] = useState(false)
     const [showMobileDeliveryCheckoutOption, setShowMobileDeliveryCheckoutOption] = useState(0);
     const [deliveryLocation, setDeliveryLocation] = useState("");
     const [pickupStateName, setPickupStateName] = useState("");
     const [isAddress, setIsAddress] = useState(false)
     const [check, setCheck] = useState("");
     const [fullName, setFullName] = useState("");
     const [email, setEmail] = useState("");
     const [phone, setPhone] = useState("");
     const [address, setAddress] = useState("");
     const [state, setState] = useState("");
     const [qty, setQty] = useState(1);
     const [isSelectedColor, setIsSelectColor] = useState(false);
     const [isSelectedSize, setIsSelectSize] = useState(false)
     const [color, setColor] = useState("");
     const [size, setSize] = useState("");
     const [stationId, setStationId] = useState("");
     const [styleSize, setStyleSize] = useState(null);
     const [styleColor, setStyleColor] = useState(null);
     const [borderColor, setBorderColor] = useState(null)
     const [customerCode, setCustomerCode] = useState("");
     const [senderLat, setSenderLat] = useState("");
     const [senderLong, setSenderLong] = useState("");
     const [senderName, setSenderName] = useState("");
     const [senderEmail, setSenderEmail] = useState("");
     const [senderPhoneNumber, setSenderPhoneNumber] = useState("");
     const [senderStationId, setSenderStationId] = useState("");
     const [senderLocality, setSenderLocality] = useState("");
     const [senderNeighborhood, setSenderNeighborhood] = useState("");
     const [recieverLGA, setRecieverLGA] = useState("");
     const [recieverCity, setRecieverCity] = useState("");
     const [destinationServiceCenterId, setDestinationServiceCenterId] = useState(null)
     const [itemName, setItemName] = useState("");
     const [itemPrice, setItemPrice] = useState("");
     const [senderAddress, setSenderAddress] = useState("")
     const [itemWeight, setItemWeight] = useState("");
     const [sizeObj, setSizeObj] = useState({})
     const [receiverCoordinate, setReceiverCoordinate] = useState({lat: null, lng: null});
     const [locationValues, setLocationValues] = useState([]);
     const [productImg, setProductImg] = useState("");
     const [productId, setProductId] = useState("");
     const [lastItemId, setLastItemId] = useState("")
     const [storeLink, setStoreLink] = useState("")
     const [itemColor, setItemColor] = useState("");
     const [verifyOrder, setVerifyOrder] = useState("");
     const [initialQty, setInitialQty] = useState(0)
     const [buyerId, setBuyerId] = useState("");
     const [userId, setUserId] = useState("");
     const [prodQuantity, setProdQuantity] = useState(0)
     const [toggle, setToggle] = useState(false);
     const [search, setSearch] = useState("");
     const [verifyCodeService, setVerifyCodeService] = useState(false);
     const [initiatePaystackService, setInitiatePaystackService] = useState(false);
     const [homeDelivery, setHomeDelivery] = useState(false);
     const [pickupServiceCenter, setPickupServiceCenter] = useState(false);
     const [selectLocationState, setSelectLocationState] = useState(false);
     const [doorDeliveryState, setDoorDeliveryState] = useState(false)
     const [deliveryMethod, setDeliveryMethod] = useState("");
     const [isAlphaStore, setIsAlphaStore] = useState("");
     const [neighborhoodName, setNeighborhoodName] = useState("");
     const [checkPickUp, setCheckPickup] = useState("");
     const [totalProducts, setTotalProducts] = useState(0);
     const closeModal = () => {
         setShowDeliveryOption(0);
         setShowMobileDeliveryOption(0)
    }
 
   const closeCheckoutOption = () => {
        setShowDeliveryCheckoutOption(0);
        setCashOnDeliveryModal(false)
        setShowMobileDeliveryCheckoutOption(0);
        setDoorDeliveryState(false);
        setSelectLocationState(false);
   }
 
    const handleMenuSwitch = (index) => {
         setShowDeliveryOption(index)
    }
    const handleDeliveryCheckout = index => {
        setShowDeliveryCheckoutOption(index)
    }
  
    const handleMobileMenuSwitch = (index) => {
       setShowMobileDeliveryOption(index)
    }
    const handleMobileDeliveryCheckout = (index) => {
      setShowMobileDeliveryCheckoutOption(index)
    }
    const handleCheck = (e) => {
        setCheck(e.target.value)
    }
  
   const emailValidation = checkValidation(patterns["email"], email);
   const phoneValidation = checkValidation(patterns["telephone"], phone);

    const changeDoorDeliveryOption = () => {
          if(check === "door-delivery-modal"){
               setShowDeliveryOption(2)
          }
          else if(check === "pick-up-modal"){
               setShowDeliveryOption(3)
          }   
    }
   const changeDoorDeliveryCheckout = () => {
          if(check === "door-delivery-modal" || deliveryMethod === "home-delivery"){
               setShowDeliveryCheckoutOption(2)
          }
          else if(check === "pick-up-modal" || deliveryMethod === "service-center"){
               setShowDeliveryCheckoutOption(3)
          }   
   }

   const handleDoorDeliveryCheckout = () => {
     if(check === "mobile-door-delivery-modal" || deliveryMethod === "mobile-home-delivery"){
          setShowMobileDeliveryCheckoutOption(2);
          refetchStations()
     }
     else if(check === "mobile-pick-up-modal" || deliveryMethod === "mobile-service-center"){
          setShowMobileDeliveryCheckoutOption(3);
          refetchStations();
     }   
}

    const changeDeliveryOptions = () => {
           if(check === "pickup-station-mobile"){
               setShowMobileDeliveryOption(8)
          }else {
               setShowMobileDeliveryOption(3)
          }
     }

     const capitalizeLetter = (str) => {
          const str1 = str?.at(0).toUpperCase();
          const restLetters = str?.slice(1);
          const capitalize = str1 + restLetters;
          return capitalize
     }
     const clearHistory = () => {
          setCheck("")
          setFullName("");
          setAddress("")
          setBuyerId("");
          setColor("");
          setEmail("");
          setInitialQty(0);
          setQty(1);
          setIsSelectColor(false);
          setIsSelectSize(false)
          setItemColor("");
          setItemPrice("")
          setItemName("");
          setItemWeight("");
          setCustomerCode("");
          setLocationValues("");
          setPhone("");
          setProdQuantity("");
          setProductId("");
          setProductImg("");
          setReceiverCoordinate("");
          setSenderAddress("");
          setSenderLat("");
          setSenderLocality("");
          setSenderLong("");
          setSenderName("");
          setSenderNeighborhood("");
          setSenderPhoneNumber("");
          setSenderStationId("");
          setDeliveryLocation("");
          setDeliveryMethod("");
          setSelectLocationState(false);
          setDoorDeliveryState(false);
          setBorderColor(null)
          setIsAlphaStore("");
          setIsAddress("");
          setNeighborhoodName("")
     }

     const clearCheckoutHistory = () => {
          setCheck("")
          setFullName("");
          setAddress("")
          setBuyerId("");
          setColor("");
          setEmail("");
          setInitialQty(0);
          setQty(1);
          setIsSelectColor(false);
          setIsSelectSize(false)
          setItemColor("");
          setItemPrice("")
          setItemName("");
          setItemWeight("");
          setCustomerCode("");
          setLocationValues("");
          setPhone("");
          setProdQuantity("");
          setProductId("");
          setProductImg("");
          setReceiverCoordinate("");
          setSenderAddress("");
          setSenderLat("");
          setSenderLocality("");
          setSenderLong("");
          setSenderName("");
          setSenderNeighborhood("");
          setSenderPhoneNumber("");
          setSenderStationId("");
          setDeliveryMethod("");
          setSelectLocationState(false);
          setDoorDeliveryState(false);
          setDeliveryLocation("");
          setBorderColor("");
          setIsAlphaStore("");
          setIsAddress("");
          setNeighborhoodName("")
     }

    const {home_delivery_loading, home_delivery, home_delivery_error} = useSelector(state => state.GetHomeDeliveryReducer);
    const {local_station_error, local_station, local_station_loading} = useSelector(state => state.LocalStationReducer);
    const getStations = local_station && local_station.results && local_station.results.Object;
    const getHomeDelivery = home_delivery && home_delivery.results && home_delivery.results.Object;

    const refetchStations = () => {
         if((getStations === undefined || getStations === "") || (getHomeDelivery === undefined || getHomeDelivery === "")){
             dispatch(localStation());
             dispatch(HomeDelivery())
         }
    }

    const stationsGet = useCallback(() => {
        dispatch(localStation());
    
   }, [dispatch]);

   const homeDeliveryGet = useCallback(() => {
     dispatch(HomeDelivery());
 
}, [dispatch]);
   

    useEffect(() => {
      stationsGet()
    }, [stationsGet]);
    useEffect(() => {
     homeDeliveryGet()
   }, [homeDeliveryGet]);
    useEffect(() => {
       dispatch(PaymentMethod())
    }, [dispatch])
    
   const {Provider} = DisplayContext;

     return <Provider value={{showDeliveryOption, setShowDeliveryOption, check, setCheck, fullName, setFullName,email, setEmail, phone, setPhone, address, setAddress, state, setState, qty, setQty, color, setColor, size, setSize, stationId, setStationId, styleSize, setStyleSize, styleColor, setStyleColor, customerCode, setCustomerCode, senderLat, setSenderLat, senderLong, setSenderLong, senderPhoneNumber, setSenderPhoneNumber, senderName, setSenderName, senderStationId, setSenderStationId, senderLocality, setSenderLocality, senderNeighborhood, setSenderNeighborhood, itemName, setItemName, itemPrice, setItemPrice, senderAddress, setSenderAddress, itemWeight, setItemWeight, receiverCoordinate, setReceiverCoordinate, locationValues, setLocationValues, productImg, setProductImg, productId, setProductId, itemColor, setItemColor, verifyOrder, setVerifyOrder, closeModal, handleCheck, handleMenuSwitch, changeDoorDeliveryOption, home_delivery_loading, home_delivery, home_delivery_error, local_station_error, local_station, local_station_loading, toggle, setToggle, changeDeliveryOptions, showMobileDeliveryOption, setShowMobileDeliveryOption, handleMobileMenuSwitch, emailValidation, phoneValidation, userId, setUserId, initialQty, setInitialQty, buyerId, setBuyerId, prodQuantity, setProdQuantity, clearHistory, search, setSearch,recieverLGA, setRecieverLGA,setRecieverCity,recieverCity,verifyCodeService, setVerifyCodeService,initiatePaystackService, setInitiatePaystackService,destinationServiceCenterId, setDestinationServiceCenterId, isSelectedColor, setIsSelectColor,isSelectedSize, setIsSelectSize, showDeliveryCheckoutOption, setShowDeliveryCheckoutOption, showMobileDeliveryCheckoutOption, setShowMobileDeliveryCheckoutOption, closeCheckoutOption,handleDeliveryCheckout,changeDoorDeliveryCheckout, clearCheckoutHistory, homeDelivery, setHomeDelivery,pickupServiceCenter, setPickupServiceCenter,selectLocationState, setSelectLocationState, doorDeliveryState, setDoorDeliveryState,deliveryMethod, setDeliveryMethod,deliveryLocation, setDeliveryLocation,pickupStateName, setPickupStateName,cashOnDeliveryModal, setCashOnDeliveryModal,handleDoorDeliveryCheckout,handleMobileDeliveryCheckout,senderEmail, setSenderEmail, storeLink, setStoreLink, lastItemId, setLastItemId,borderColor, setBorderColor,isAlphaStore, setIsAlphaStore, neighborhoodName, setNeighborhoodName,isAddress, setIsAddress, refetchStations,sizeObj, setSizeObj, capitalizeLetter, totalProducts, setTotalProducts,checkPickUp, setCheckPickup}}>
           {children}
     </Provider>
}
export default DisplayContextProvider